import React from 'react';
import './ManagerCoachingEffectivenessWidget.styl';
import WidgetHeader from 'components/manager-dashboard/WidgetHeader';
import {Link} from 'react-router';
import {Toggle} from 'material-ui';
import ManagerCoachingEffectivenessTable, {gatherData} from './ManagerCoachingEffectivenessTable';
import AuthStore from 'stores/AuthStore';
import round from 'utils/round';
import WebDataRocksActions, {
  WebDataType,
  xlsxDateFormat,
} from '@store/web-data-rocks/WebDataRocksActions';
import WebDataButton from 'components/utils/WebDataButton';
import Button from '@material-ui/core/Button';

export default class ManagerCoachingEffectivenessWidget extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      includeMeetingTime: true,
      includeReviewTime: true,
    };

    this.toggleMeetingTime = this.toggleMeetingTime.bind(this);
    this.toggleReviewTime = this.toggleReviewTime.bind(this);
  }

  getWebData = () => {
    const {startDate, endDate} = this.props;
    return gatherData({...this.props, ...this.state})
      .map(d => ({
        'Rep Email': d.rep.email,
        'Start Date': startDate.format(xlsxDateFormat),
        'End Date': endDate.format(xlsxDateFormat),
        'Coach Email': d.coachedBy.map(c => c.user.email).join(','),
        'Hours of Coaching Total': round(d.coachingTimeReceived.total.asHours()),
        'Hours of Coaching From Manager': round(d.coachingTimeReceived.manager.asHours()),
        'Rep Call Score % Change': d.scoreTrend.trend && `${d.scoreTrend.trend}%`,
        'Rep Call Score Rank': d.scoreRank.rank,
        'Rep Call Score Rank Change': d.scoreRank.delta,
        'Rep Call Activity % Change': d.activityTrend.trend && `${d.activityTrend.trend}%`,
        'Rep Call Activity Rank': d.activityRank.rank,
        'Rep Call Activity Rank Change': d.activityRank.delta,
      }))
      .toJS();
  };

  webDataOnClick = () => {
    WebDataRocksActions.showDialog('Manager Coaching Effectiveness');
    // Dialog needs to be visible before data is set, so we need to show, then defer the setData call.
    setTimeout(() =>
      WebDataRocksActions.setData(WebDataType.MANAGER_COACHING_ACTIVITY, this.getWebData())
    );
  };

  render() {
    const {showMoreLink, viewForCoach} = this.props;

    let pageHeader;
    let subheader;
    if (!viewForCoach) {
      const manager = this.props.managerId && this.props.users.get(this.props.managerId);
      pageHeader = this.props.managerId
        ? `Coaching Received By ${manager.firstName}'s Team`
        : 'Coaching Effectiveness';
    } else {
      const coach = this.props.coachId && this.props.users.get(this.props.coachId);
      pageHeader = `${coach ? coach.firstName + "'s" : ''} coaching effectiveness`;
      const iAmCoach = AuthStore.getState().user.id === this.props.coachId;
      subheader = !viewForCoach
        ? null
        : `Reps that ${
            iAmCoach ? 'you have' : `${coach.firstName} has`
          } coached vs change in performance`;
    }

    return (
      <div className="widget manager-coaching-effectiveness-widget">
        <WidgetHeader {...this.props} showDates={true} title={pageHeader} subheader={subheader}>
          <WebDataButton onClick={this.webDataOnClick} tooltip="Export" />
          {!viewForCoach && (
            <div className="toggles">
              <div>Include</div>
              <Toggle
                className="review-toggle"
                label="Call review time"
                labelPosition="right"
                toggled={this.state.includeReviewTime}
                onToggle={this.toggleReviewTime}
              />
              <Toggle
                className="coaching-toggle"
                label="Coaching meeting time"
                labelPosition="right"
                toggled={this.state.includeMeetingTime}
                onToggle={this.toggleMeetingTime}
              />
            </div>
          )}
        </WidgetHeader>
        <ManagerCoachingEffectivenessTable {...this.props} {...this.state} />
        {showMoreLink && (
          <div className="show-more-link">
            <Button component={Link} variant="text" to={showMoreLink}>
              Show More
            </Button>
          </div>
        )}
      </div>
    );
  }

  toggleMeetingTime() {
    const {includeMeetingTime, includeReviewTime} = this.state;
    const newIncludeMeetingTime = !includeMeetingTime;
    if (newIncludeMeetingTime || includeReviewTime) {
      this.setState({
        includeMeetingTime: newIncludeMeetingTime,
      });
    } else {
      this.setState({
        includeMeetingTime: false,
        includeReviewTime: true,
      });
    }
  }

  toggleReviewTime() {
    const {includeMeetingTime, includeReviewTime} = this.state;
    const newIncludeReviewTime = !includeReviewTime;
    if (newIncludeReviewTime || includeMeetingTime) {
      this.setState({
        includeReviewTime: newIncludeReviewTime,
      });
    } else {
      this.setState({
        includeMeetingTime: true,
        includeReviewTime: false,
      });
    }
  }
}
